<template>
    <div>
      <HeaderTop></HeaderTop>
      <div class="paperPage">
        <div class="mid">
          <div class="mianbao mt2 d-flex d-flex-between">
            <div class="bread">
              <span class="dq">当前位置：</span>
              <span @click="toRouter('/main/home')" class="mba  click">个人中心</span> &gt;
              <span @click="toRouter('/main/homework')" class="mba  click" v-if="type=='HOMEWORK'">综合评价作业</span>
              <span @click="toRouter('/main/exam')" class="mba  click" v-else>综合评价考试</span>
                &gt;
              <span class="site " >详情</span>
            </div>
            <el-button size="small" @click="goBack" class="backBtn">返回</el-button>
          </div>
          <div class="content">
            <div class="paperInfo">
              <p class="paperTitle">{{ paperData.name }}</p>
              <div class="descBox d-flex d-flex-middle d-flex-center">
                <p>课程: {{ paperData.courseCode+'-'+paperData.courseName }}</p>
                <p>考试时间：{{ paperData.duration }}分钟</p>
                <p>卷面总分：{{ paperData.totalScore }}分</p>
                <p v-if="paperData.exam.status == 'EFFECT'">我的成绩：<b class="score">{{ myScore }}分</b></p>
              </div>
              <div class="scoreTable" v-if="type=='EXAMINE'">
                <table border style="text-align: center;">
                  <tr>
                    <td>题序</td>
                    <td v-for="(v, i) in sections" :keys="i">
                      {{ numToCapital(i + 1) }}
                    </td>
                    <td>总分</td>
                  </tr>
                  <tr>
                    <td>得分</td>
                    <td v-for="(v, i) in sections" :keys="i">{{paperData.exam.status == 'EFFECT' ? v.sectionScore : '--'}}</td>
                    <td>{{paperData.exam.status == 'EFFECT' ? allScore : '--'}}</td>
                  </tr>
                  <tr>
                    <td>评卷人</td>
                    <!-- <td v-for="(v, i) in sections" :keys="i"></td> -->
                    <td colspan="3">{{ paperData.checkName }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="paperBox">
              <div class="list">
                <div class="li" v-for="(item, index) in sections" :key="index">
                  <div class="titleBox" v-if="item.questions">
                    <p>{{ index+1 }}、{{ item.name || item.questionType }} （本大题共{{item.questions.length}}小题，每小题{{ item.questions[0].score }}分，共{{item.questions[0].score * item.questions.length}}分）
                    </p>
                  </div>
                  <div
                    class="liBox"
                    v-for="(question, indexQ) in item.questions"
                    :key="'q' + indexQ"
                    :id="'Q-' + question.id"
                  >
                    
                    <!-- 套题 -->
                    <template v-if="question.type == 'TT'">
                      <div class="title fontSize32">
                        ({{ Number(indexQ) + 1 }})、<span
                          v-html="reformHtml(question.content)"
                        ></span>
                      </div>
                      <div
                        class="boxView"
                        v-for="(q, qi) in question.children"
                        :key="'q_' + qi"
                      >
                        
                        <template
                          v-if="q.type == 'SINGLECHOICE' || q.type == 'MULTIPLECHOICE' || q.type == 'JUDGMENT'"
                        >
                          <choice
                            :info="q"
                            :no="qi"
                            :readOnly="true"
                            :showAnswer = "paperData.showAnswer"
                            :answerExpose = "paperData.answerExpose"
                          ></choice>
                        </template>
                        <template v-else-if="q.type == 'BLANKFILL'">
                          <blank
                            :info="q"
                            :no="qi"
                            :readOnly="true"
                            :showAnswer = "paperData.showAnswer"
                            :answerExpose = "paperData.answerExpose"
                          ></blank>
                        </template>
                        <template v-else>
                          <essay
                            :info="q"
                            :no="qi"
                            :readOnly="true"
                            :showAnswer = "paperData.showAnswer"
                            :answerExpose = "paperData.answerExpose"
                          ></essay>
                        </template>
                      </div>
                    </template>
                    <!-- 非套题 -->
                    <template v-else>
                      <template
                        v-if="
                          question.type == 'SINGLECHOICE' ||
                          question.type == 'MULTIPLECHOICE' ||
                          question.type == 'JUDGMENT'
                        "
                      >
                        <choice
                          :info="question"
                          :no="indexQ"
                          :readOnly="true"
                          :showAnswer = "paperData.showAnswer"
                          :answerExpose = "paperData.answerExpose"
                        ></choice>
                      </template>
                      <template v-else-if="question.type == 'BLANKFILL'">
                        <blank
                          :info="question"
                          :no="indexQ"
                          :readOnly="true"
                          :showAnswer = "paperData.showAnswer"
                          :answerExpose = "paperData.answerExpose"
                        ></blank>
                      </template>
                      <template v-else>
                        <essay
                          :info="question"
                          :no="indexQ"
                          :readOnly="true"
                          :showAnswer = "paperData.showAnswer"
                          :answerExpose = "paperData.answerExpose"
                        ></essay>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottomBox d-flex d-flex-center d-flex-middle" v-if="redo">
              <el-button type="primary" size="small" @click="redoFn" class="baseBtn">重做</el-button>
            </div>
            <!-- 主观题答案 -->
            <div class="imgBox" v-if="dtkPics.length > 0">
              <p class="img_title">上传的答题卡</p>
              <div class="imgs">
                <div class="box" v-for="(dtk, dtk_i) in dtkPics" :key="dtk_i">
                  <el-image
                    :src="dtk.url"
                    :preview-src-list="[dtk.url]"
                    class="img"
                    v-if="ImgType(dtk.url)"
                  ></el-image>
                  <div class="fileBox" v-else>
                    <img
                      :title="fileNameFn(dtk.url)"
                      :src="require('@/assets/images/File.png')"
                      class="fileImg"
                      @click="openFile(dtk.url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 倒计时 -->
          </div>
          <!-- 答题卡 -->
          <div class="answerBox">
            <cardList
              :list="sections"
              @position="position"
              :readOnly="true"
              :showUpload="true"
              :redo="redo"
              :check="paperData.checks"
              @redo="redoFn"
            ></cardList>
          </div>
        </div>
      </div>
      <Footer></Footer>
    <faceRecognition ref="faceRecognition" type="paper" @submit="toStart" ></faceRecognition>
    </div>
  </template>
  
  <script>
  import HeaderTop from "@/components/HeaderTop.vue";
  import Footer from "@/components/Footer.vue";
  import choice from "@/components/question/choice.vue";
  import blank from "@/components/question/blank.vue";
  import essay from "@/components/question/essay.vue";
  import cardList from "@/components/question/cardList.vue";
  import faceRecognition from "@/components/faceRecognition.vue";
  export default {
    components: {
      HeaderTop,
      Footer,
      choice,
      blank,
      essay,
      cardList,
      faceRecognition
    },
    data() {
      return {
        myScore:'',
        type:'',
        paperId: "",
        examDataId:"",
        examConfigId:'',
        // 
        paperData:{},
        courseId:'',
        //
        dtkPics: [],
        // 
        redo: false,
        sections: [],
        allScore:0
        //
      };
    },
    created() {
      this.myScore = this.$route.query.myScore
      this.type = this.$route.query.type
      this.paperId = this.$route.query.id
      this.examDataId = this.$route.query.examDataId
      this.examConfigId = this.$route.query.examConfigId
      this.viewType = this.$route.query.viewType
      this.getInfo()
    },
    methods: {
        toRouter(path) {
      this.$router.push({ path })
    },
        goBack() {
      this.$router.back()
    },
      numToCapital(num, type) {
        if (!num) return 0;
        const strNum = Number((num + "").replace(/[,，]*/g, "")) + ""; // 记录字符
        num = parseInt(Number(strNum)); // 转为整数，
        let capitalAr = "零一二三四五六七八九十";
        let unitAr = [
          "十",
          "百",
          "千",
          "万",
          "十",
          "百",
          "千",
          "亿",
          "十",
          "百",
          "千",
        ];
        if (type) {
          capitalAr = "零壹贰叁肆伍陆柒捌玖拾";
          unitAr = [
            "拾",
            "佰",
            "仟",
            "万",
            "拾",
            "佰",
            "仟",
            "亿",
            "拾",
            "佰",
            "仟",
          ]; // 单位
        }
        const resultAr = []; // 记录结果，后边json.in就可
        let index = strNum.length - 1; //记录位数
        let idx = 0; // 记录单位
        let percent = 10;
        const turnNum = (num, percent, index) => {
          const unit = num / percent;
          const capital = capitalAr[Number(strNum[index])];
          if (unit < 1) {
            resultAr.push(capital);
            // 出现11【一十一】这种情况
            if (
              Number(strNum[index]) === 1 &&
              (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)
            ) {
              resultAr.pop();
            }
            return false; //结束递归
          } else {
            if (capital === "零") {
              // 万和亿单位不删除
              if (!["万", "亿"].includes(resultAr[resultAr.length - 1])) {
                resultAr.pop();
              }
              // 前面有零在删掉一个零
              if (resultAr[resultAr.length - 1] === "零") {
                resultAr.pop();
              }
            }
            resultAr.push(capital);
            // 过滤存在【零万】【零亿】这种情况
            if (
              ["万", "亿"].includes(resultAr[resultAr.length - 2]) &&
              capital === "零"
            ) {
              resultAr.pop();
            }
            // 过滤【1亿万】这种情况
            if (resultAr[0] === "万" && resultAr[1] === "亿") {
              resultAr.shift();
            }
            // 末尾【零】删掉
            if (resultAr[0] === "零") {
              resultAr.pop();
            }
            resultAr.push(unitAr[idx++]);
            turnNum(num, percent * 10, --index);
          }
        };
        turnNum(num, percent, index);
        return resultAr.reverse().join("");
      },
      getInfo() {
        var that = this;
        this.$http.get("/student/app/paper/info", { paperId: this.paperId,examDataId: this.examDataId,type:this.viewType }).then((res) => {
          this.courseId = res.courseId
          // 
          if(res.showTime){
            var givenDate = new Date(res.showTime);
            var currentDate = new Date();
            var timeDifference = currentDate.getTime() - givenDate.getTime();
            // 将毫秒差值转换为秒
            if(parseInt(timeDifference / 1000) < 0){
              res.showAnswer = false
              res.answerExpose = false
            }
          }
          
          // 
          this.paperData = res
          this.makeInfo(res.sections, res.answers);
          this.dtkPics = res.answerCards || [];
          this.redo =false// this.type =='HOMEWORK' && this.getUseStatus(res) && (res.exam.status == 'AUTOMATIC_REVISED' || res.exam.status == 'MANUAL_REVISED')
          console.log(this.redo )
          if(res.checks){
            let score=0
            for (const key in res.checks) {
                const s = res.checks[key];
                score+=+s||0
            }
            this.allScore=score
          }
          this.myScore = res.exam?.score

        });
      },
      getUseStatus(data){
        const currentTime = new Date();
        const start = new Date(data.startTime);
        const end = new Date(data.endTime);
        return currentTime >= start && currentTime <= end;
      },
      makeInfo(res, answers) {
        //处理数据格式
        var that = this;
        res.map((item, index) => {
          item.type = item.questions[0].type;
          item.questions.map((v, i) => {
            if (v.type == "SINGLECHOICE" || v.type == "JUDGMENT") {
              // 单选、判断
              v.myAnswer = answers[v.id] ? answers[v.id] : "";
            } else if (v.type == "MULTIPLECHOICE") {
              //多选
              v.myAnswer = answers[v.id] ? answers[v.id].split("") : [];
            } else if (v.type == "BLANKFILL") {
              //填空
              v.myAnswer = [];
              if (answers[v.id]) {
                v.myAnswer = answers[v.id].split("`");
              } else {
                v.blanks.map((x) => {
                  v.myAnswer.push("");
                });
              }
            } else if (item.type == "TT") {
              //套题
              v.children.map((v_, i_) => {
                if (v_.type == "SINGLECHOICE" || v_.type == "JUDGMENT") {
                  // 单选、判断
                  v_.myAnswer = answers[v_.id] ? answers[v_.id] : "";
                } else if (v_.type == "MULTIPLECHOICE") {
                  //多选
                  v_.myAnswer = answers[v_.id] ? answers[v_.id].split("") : [];
                } else if (v_.type == "BLANKFILL") {
                  //填空
                  v_.myAnswer = [];
                  if (answers[v_.id]) {
                    v_.myAnswer = answers[v_.id].split("`");
                  } else {
                    v_.blanks.map((x) => {
                      v_.myAnswer.push("");
                    });
                  }
                } else {
                  //文本
                  v_.myAnswer = answers[v_.id] ? answers[v_.id] : "";
                }
              });
            } else {
              //文本
              v.myAnswer = answers[v.id] ? answers[v.id] : "";
            }
          });
        });
        this.sections = res;
      },
      ImgType(url) {
        const lastDotIndex = url.lastIndexOf(".");
        if (lastDotIndex === -1) {
          return null; // URL中没有文件扩展名
        }
        const fileExtension = url.slice(lastDotIndex + 1);
        if (
          fileExtension == "jpg" ||
          fileExtension == "png" ||
          fileExtension == "jpeg"
        ) {
          return true;
        } else {
          return false;
        }
      },
      fileNameFn(url) {
        const lastSlashIndex = url.lastIndexOf("/");
        if (lastSlashIndex === -1) {
          return null; // URL中没有文件名
        }
        const fileName = url.slice(lastSlashIndex + 1);
        return fileName;
      },
      openFile(url) {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = this.fileNameFn(url);
        a.style.display = "none";
        document.body.append(a);
        a.click();
        document.body.removeChild(a); // 移除
      },
      reformHtml(html) {
        var reg = new RegExp("\\[BlankArea\\d]", "g");
        html = html.replace(reg, "____");
        return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
      },
      position(id) {
        //答题卡锚点定位
        const anchorEle = document.querySelector("#Q-" + id);        
        if (!!anchorEle) {
          // anchorEle.scrollIntoView(true);
          var rect = anchorEle.getBoundingClientRect();
          window.scrollTo(0,rect.top + window.scrollY-120);
        }
      },
      redoFn() {
        //重做
        this.$confirm("确定要重做（点击“确定”按钮后会清空这个成绩）？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then((res) => {
          if (res == "confirm") {
            this.start()
          }
        });
      },
      start(){
        if(this.paperData.faceComparison=='1'){ //人脸识别
            this.$refs.faceRecognition.open({
                courseId:this.courseId,
                paperId:this.paperId
            })
        }else{
            this.toStart()
        }
    },
    toStart(){
        window.sessionStorage.setItem(this.paperId,new Date())
        this.$http.post('/student/pc/paper/start',{
            paperId: this.paperId,
            examConfigId: this.examConfigId
        }).then((res) => {
            this.$router.push('/paper?type='+this.type+'&id='+this.paperId+'&examDataId='+res)
        })
    }
    },
  };
  </script>
  <style lang="scss" scoped>
  .paperPage {
    padding-top: 90px;
    min-height: calc(100% - 200px);
    font-size: 14px;
    p{
      margin: 0;
    }
    .mianbao{
        color: #666;
        margin-bottom: 20px;
        .bread {
          display: flex;
          align-items: center;
        }
        .dq {
          color: #999;
        }
        .mba, .site {
          color: #666;
        }
        .click {
          color: #409EFF;
          cursor: pointer;
        }
        .click:hover {
          text-decoration: underline;
        }
        .backBtn {
          color: #666;
          background: #fff;
          border: 1px solid #dcdfe6;
        }
        .backBtn:hover {
          color: #409EFF;
          border-color: #409EFF;
        }
      }
    .mid {
      width: 1200px;
      margin: 0 auto 30px auto;
      overflow: hidden;
      min-height: calc(100vh - 310px);
      .content {
        width: 830px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.25);
        border-radius: 10px;
        box-sizing: border-box;
        padding: 30px 0;

      }
      .paperInfo {
        .paperTitle {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          color: #333;
        }
        .descBox {
          margin: 20px auto;
          p {
            margin: 0 30px;
            font-size: 14px;
            color: #999999;
          }
          .score{
            display: inline-block;
            height: 20px;
            line-height: 20px;
            background: #FFA800;
            color: #fff;
            border-radius: 10px;
            margin-left: 10px;
            text-align: center;
            box-sizing: border-box;
            padding: 0 5px;
            font-size: 13px;
          }
        }
        .scoreTable {
          width: 90%;
          margin: 10px auto;
          table {
            width: 100%;
            border: 1px solid;
            border-collapse: collapse;
            border-spacing: 10px 50px;
            td {
              border: 1px solid #c2c2c2;
              color: #666;
              font-size: 14px;
              padding: 5px;
              line-height: 22px;
              &:nth-of-type(1) {
                width: 60px;
              }
            }
          }
        }
      }
      .paperBox {
        width: 90%;
        margin: 0 auto;
        .list {
          .li {
            background: #fff;
            margin-bottom: 15px;
            border-bottom: 1px solid #F2F2F2;
            .titleBox {
              box-sizing: border-box;
              padding: 10px 0;
            }
            .liBox {
              margin: 20px 0;
              position: relative;
              .functionBox {
                position: absolute;
                top: -7.5px;
                right: 0;
                background: #fff;
                box-sizing: border-box;
                padding: 5px 10px;
                border-radius: 5px;
                box-shadow: 0 0 10px #ddd;
                z-index: 22;
                .collectBox {
                  margin-left: 10px;
                  img {
                    width: 24px;
                    height: 24px;
                  }
                }
              }
              .boxView {
                position: relative;
                .functionBox {
                  top: 0;
                }
              }
            }
          }
        }
      }
      .answerBox {
        width: 320px;
        box-sizing: border-box;
        padding: 0 10px;
        box-shadow: 0px 3px 10px 0px rgba(153, 153, 153, 0.25);
        border-radius: 10px;
        position: fixed;
        right: calc(50% - 600px);
        top: 170px;
        background: #fff;
        z-index: 99;
        overflow: hidden;
        .timeBox{
          height: 80px;
          border-bottom: 1px solid #f2f2f2;
          font-size: 16px;
          b{
            color: #FFA800;
            font-size: 34px;
            margin-left: 10px;
            font-weight: 500;
          }
        }
      }
      .bottomBox {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        .uploadBtn {
          margin-left: 15px;
        }
      }
      .imgBox {
        box-sizing: border-box;
        padding: 0 10px;
        border: 1px solid #ddd;
        border-radius: 5px;
        background: #fff;
        margin-bottom: 15px;
        width: 90%;
        margin: 30px auto;
        .img_title {
          box-sizing: border-box;
          padding: 10px;
          border-bottom: 1px solid #eee;
        }
        .imgs {
          display: flex;
          justify-items: center;
          flex-wrap: wrap;
          .box {
            box-shadow: 0 0 1px;
            margin: 10px;
            position: relative;
            border-radius: 5px;
            width: 100px;
            height: 100px;
            .img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
              cursor: pointer;
            }
            .fileBox {
              width: 100%;
              height: 100%;
              img {
                width: 60%;
                height: 60%;
                position: relative;
                top: 20%;
                left: 20%;
                cursor: pointer;
              }
            }
            .icon {
              position: absolute;
              top: -8px;
              right: -8px;
              font-size: 20px;
              color: red;
              cursor: pointer;
              background: #fff;
              border-radius: 50%;
            }
          }
        }
      }
      .scoreBox {
        height: 16px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
    }
  }
  </style>
    